import { useAuthStore } from '@/stores/auth';

/**
 * Called once before React mounts. Tries to silently restore a session by
 * exchanging the (httpOnly) refresh-token cookie for a fresh JWT. If that
 * works, the auth store is hydrated and protected routes render directly
 * instead of bouncing the user to /login on every page reload.
 */
export async function tryRestoreSession(): Promise<void> {
  try {
    const res = await fetch('/auth/token/refresh', {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
    });
    if (!res.ok) return;
    const data = (await res.json()) as { token?: string };
    if (data.token) {
      useAuthStore.getState().setToken(data.token);
    }
  } catch {
    /* offline or network error – proceed to login */
  }
}
